/* eslint-disable camelcase */
import { InvoiceTemplateStatusEnum } from '../enums/invoiceTemplateStatus.enum';
import { BaseOptions } from './baseOptions';

export class InvoiceTemplateOptions extends BaseOptions {
  owner_id?: number;

  status?: InvoiceTemplateStatusEnum;

  showFormInfo?: boolean;

  filter?: string;

  // CSV med flera malltyper, t.ex. 'member,autogiro,swish'. Används av admin-översikten för att visa
  // medlemsavgift-familjen. Skickas inte av övriga anrop (de får endast medlemsmallar som tidigare).
  types?: string;

  constructor(params: Partial<InvoiceTemplateOptions> = {}) {
    super();

    if (params.pageIndex !== undefined) this.pageIndex = params.pageIndex;
    if (params.pageSize !== undefined) this.pageSize = params.pageSize;
    this.sortCol = params.sortCol ?? 'owner_id';
    this.sortDir = params.sortDir ?? 'desc';

    this.owner_id = params.owner_id;
    this.status = params.status;
    this.showFormInfo = params.showFormInfo ?? undefined;
    this.filter = params.filter ?? '';
    this.types = params.types;
  }
}
